import { render, staticRenderFns } from "./TableScrollbarHelper.vue?vue&type=template&id=453eae8a&scoped=true"
import script from "./TableScrollbarHelper.vue?vue&type=script&lang=js"
export * from "./TableScrollbarHelper.vue?vue&type=script&lang=js"
import style0 from "./TableScrollbarHelper.vue?vue&type=style&index=0&id=453eae8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453eae8a",
  null
  
)

export default component.exports